export const sygnet = ['160 160', `
  <title>RodeDoc Logo</title>
  <g>
    
  </g>
`]
